import { IsNumber, IsOptional, IsString } from 'class-validator';
import { WebPaymentTypeEnum } from '@up/data';

export class FireOpenWebPaymentRequestDto {
  webPaymentType: WebPaymentTypeEnum;

  @IsNumber()
  amount: number;

  @IsNumber()
  referenceId: number;

  @IsNumber()
  merchantId: number;

  @IsOptional()
  @IsString()
  description?: string;

  @IsOptional()
  @IsString()
  currency?: string;

  @IsOptional()
  @IsString()
  myRef?: string;

  @IsOptional()
  @IsString()
  returnUrl?: string;

  @IsOptional()
  @IsNumber()
  paymentMethodId?: number;
}
